module.exports = __webpack_public_path__ + "static/media/breakfast-brunch-tablet-738x57.e183d964.webp";